import React, { useEffect, useState } from 'react';
import Alert from "@mui/material/Alert";
import { insertDataJson, getData, formatMoney, updateItem, insertData } from '../../Tools/helpers';
import ModalAccount from './ModalAccount';
import ModalStudentRegistration from './ModalStudentRegistration';
import FinancialSummary from './FinancialSummary';
import ModalUsers from './ModalUsers';
import FranchiseStats from './FranchiseStats';

const UniversityManagementSystem = () => {
  const [franchises, setFranchises] = useState([]);
  const [universityID, setUniversityID] = useState(null);
  const [globalSummary, setGlobalSummary] = useState({});
  const [updateInvoiceData, setUpdateInvoiceData] = useState(false);

  const [message, setMessage] = useState({
    status: false,
    message: "",
    label: "",
  });

  const [messageGeneral, setMessageGeneral] = useState({
    status: false,
    message: "",
    label: "",
  });

  // Estados para el formulario de captura
  const [formData, setFormData] = useState({
    university: {
      name: '',
      address: '',
      short_name: '',
      period_date_ini: '',
      academic_period: 6,
      phone: ''
    },
    franchise: {
      name: '',
      address: '',
      phone: '',
      phone2: '',
      email: '',
      name_contact: '',
      phone_contact: '',
      email_contact: '',
      status: 'Activo'
    },
    costs: {
      cost_month_student: 0,
      cost_month_lic: 0,
      cost_month_master: 0,
      cost_month_doctorate: 0,
      cost_month_health: 0,
      cost_month_engineering: 0,
      cost_month_specialty: 0,
      cost_month_diploma: 0,
      cost_inscription: 0,
      cost_reinscription: 500,
      cost_degree: 0,
      cost_degree_lic: 0,
      cost_degree_engineering: 0,
      cost_degree_master: 0,
      cost_degree_doctorate: 0,
      cost_degree_health: 0,
      late_payment: 0
    }
  });

  const [selectedFranchise, setSelectedFranchise] = useState(null);
  const [activeTab, setActiveTab] = useState('franchise');
  const [showForm, setShowForm] = useState(false);
  const [showAccountStatement, setShowAccountStatement] = useState(false);
  const [showModalUsers, setShowModalUsers] = useState(false);
  const [accountStatements, setAccountStatements] = useState({});
  const [selectedMonth, setSelectedMonth] = useState('');
  const [creditBalanceFranchis, setCreditBalanceFranchis] = useState(0);
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [showStudentModal, setShowStudentModal] = useState(false);
  const [updateFranchise, setUpdateFranchise] = useState(false);
  const [franchiseStats, setFranchiseStats] = useState([]);
  const [franchiseListTab, setFranchiseListTab] = useState('active');


  // Manejar cambios en los inputs
  const handleInputChange = (section, field, value) => {
    setFormData(prev => ({
      ...prev,
      [section]: {
        ...prev[section],
        [field]: value
      }
    }));
  };

  // Enviar el formulario
  const handleSubmit = async (e) => {
    setMessage({
      status: false,
      message: "",
      label: "",
    });

    e.preventDefault();

    if(
      Number(formData.costs.cost_month_lic) === 0 ||
      Number(formData.costs.cost_month_master) === 0 ||
      Number(formData.costs.cost_month_doctorate) === 0 ||
      Number(formData.costs.cost_month_health) === 0 ||
      Number(formData.costs.cost_month_engineering) === 0 ||
      Number(formData.costs.cost_inscription) === 0 ||
      Number(formData.costs.cost_reinscription) === 0 ||
      Number(formData.costs.late_payment) === 0
    )
      {
      setMessage({
        status: true,
        message: "Los costos (*) son requeridos",
        label: "error",
      });
      return;
    }

    if(
      formData.franchise.name === '' || 
      formData.franchise.email === '' ||
      formData.franchise.name_contact === '' ||
      formData.university.short_name === '' ||
      formData.university.name === '' ||
      formData.university.phone === ''
    )
      {
      setMessage({
        status: true,
        message: "Los campos con (*) son requeridos",
        label: "error",
      });
      return;
    }

    setMessage({
      status: true,
      message: "Guardando...",
      label: "info",
    });
    
    const newFranchise = {
      name: formData.franchise.name,
      email: formData.franchise.email,
      name_contact: formData.franchise.name_contact,
      phone_contact: formData.franchise.phone_contact,
      status: formData.franchise.status,
      details: {
        university_name: formData.university.name,
        short_name: formData.university.short_name,
        phone: formData.university.phone,
        address: formData.university.address,
        academic_period: formData.university.academic_period,
        period_date_ini: formData.university.period_date_ini,
        university_id: formData.university?.university_id ?? null,
        cost_month_student: parseFloat(formData.costs.cost_month_student),
        cost_month_lic: parseFloat(formData.costs.cost_month_lic),
        cost_month_engineering: parseFloat(formData.costs.cost_month_engineering),
        cost_month_master: parseFloat(formData.costs.cost_month_master),
        cost_month_doctorate: parseFloat(formData.costs.cost_month_doctorate),
        cost_month_health: parseFloat(formData.costs.cost_month_health),
        cost_month_specialty: parseFloat(formData.costs.cost_month_specialty),
        cost_month_diploma: parseFloat(formData.costs.cost_month_diploma),
        cost_inscription: parseFloat(formData.costs.cost_inscription),
        cost_reinscription: parseFloat(formData.costs.cost_reinscription),
        cost_degree: parseFloat(formData.costs.cost_degree),
        cost_degree_lic: parseFloat(formData.costs.cost_degree_lic),
        cost_degree_engineering: parseFloat(formData.costs.cost_degree_engineering),
        cost_degree_master: parseFloat(formData.costs.cost_degree_master),
        cost_degree_doctorate: parseFloat(formData.costs.cost_degree_doctorate),
        cost_degree_health: parseFloat(formData.costs.cost_degree_health),
        late_payment: parseFloat(formData.costs.late_payment)
      }
    };

    setFranchises([...franchises, newFranchise]);

    const route = 'Franchise';
    let send = null;

    if(updateFranchise){
      send = await updateItem(`${route}/${formData.franchise?.id}`, newFranchise);
    }else{
      send = await insertDataJson(route, newFranchise);
    }

    if (send.code === 201 || send.code === 200) {
      setMessage({
        status: true,
        message: "Se ha guardado correctamente",
        label: "success",
      });
      resetForm();
      getUniversities();
      if(updateFranchise){
        setShowForm(false);
      }
      return;
    }

    if (send.status === "error") {
      setMessage({
        status: true,
        message: send.message,
        label: "error",
      });
      return;
    }

    setMessage({
      status: true,
      message: "Ha ocurrido algo",
      label: "error",
    });

  };

  const resetForm = () => {
    setFormData({
      university: {
        name: '',
        address: '',
        short_name: '',
        period_date_ini: '',
        academic_period: 6,
        phone: ''
      },
      franchise: {
        name: '',
        address: '',
        phone: '',
        phone2: '',
        email: '',
        name_contact: '',
        phone_contact: '',
        email_contact: '',
        status: 'Activo'
      },
      costs: {
        cost_month_lic: 0,
        cost_month_engineering: 0,
        cost_month_master: 0,
        cost_month_doctorate: 0,
        cost_month_health: 0,
        cost_month_specialty: 0,
        cost_month_diploma: 0,
        cost_inscription: 0,
        cost_reinscription: 500,
        cost_inscription_lic: 0,
        cost_inscription_engineering: 0,
        cost_inscription_master: 0,
        cost_inscription_doctorate: 0,
        cost_inscription_health: 0,
        cost_degree: 0,
        late_payment: 0
      }
    });
  }

  const toggleDeactivate = async (franchise) => {
    setMessage({
      status: false,
      message: "",
      label: "",
    });
    
    if (!franchise) {
      return;
    }

    const franchise_id = franchise.franchises_universities?.franchise?.id;
    const franchise_status = franchise.franchises_universities?.franchise?.status;

    setMessage({
      status: true,
      message: "Aplicando...",
      label: "info",
    });

    const dataStatus = {
      status: franchise_status === 'Activo' ? 'Desactivado' : 'Activo',
    };

    const route = 'Franchise';
    const send = await updateItem(`${route}/${franchise_id}`, dataStatus);

    if (send.code === 200) {
      setMessage({
        status: true,
        message: `Se ha ${send.data?.status} correctamente`,
        label: "success",
      });
      getUniversities();
      return;
    }
    setMessage({
      status: true,
      message: "Ha ocurrido algo, intente de nuevo",
      label: "error",
    });
  }

  const toggleArchive = async (franchise) => {
    const franchiseId = franchise.franchises_universities?.franchise?.id;
    const isArchived = !!franchise.franchises_universities?.franchise?.archived_at;
    const route = isArchived
      ? `Franchise/${franchiseId}/unarchive`
      : `Franchise/${franchiseId}/archive`;
    const send = await insertDataJson(route, {});
    if (send.code === 200) {
      getUniversities();
      setSelectedFranchise(null);
    }
  };

  useEffect(()=>{
    if(updateInvoiceData){
      getAccountStatements(universityID);
      getGlobalSummary();
    }
  },[updateInvoiceData])

  const getAccountStatements = async (university_id, year = null) => {
    const yearParam = year ? `?year=${year}` : '';
    const route = `Franchise-Invoice/${university_id}${yearParam}`;
    const send = await getData(route);
    if (send.code === 200) {
      setAccountStatements(send.data.history);
      if (!year) setSelectedMonth(send.data.actual_period);
      setCreditBalanceFranchis(send.data.credit_balance ?? 0);
      setUpdateInvoiceData(false);
    }
  };

  const getUniversities = async () => {
    setMessageGeneral({
      status: true,
      message: "Consultando...",
      label: "info",
    });
    const route = 'Franchise-University';
    const send = await getData(route);
    if (send.code === 200) {
      setFranchises(send.data);
      setMessageGeneral({
        status: true,
        message: "Consulta exitosa",
        label: "success",
      });
    }
  };

  const getFranchiseStats = async () => {
    const route = 'Franchise-Stats';
    const send = await getData(route);
    if (send.code === 200) {
      setFranchiseStats(send.data);
      return;
    }
    setMessage({
      status: true,
      message: send.message || 'Error al cargar estadísticas',
      label: 'error',
    });
  };

  const getGlobalSummary = async () => {
    const route = 'Franchise-Invoice';
    const send = await getData(route);
    if (send.code === 200) {
      setGlobalSummary(send.data);
      return;
    }
    setMessageGeneral({
      status: true,
      message: "No se pudo cargar la información",
      label: "error",
    });
  };

  useEffect(() => {
    getGlobalSummary();
    getUniversities();
    getFranchiseStats();
  }, []);

  useEffect(()=>{
    setSelectedInvoice(accountStatements[selectedMonth]?.summary?.invoice_id)
  },[selectedMonth])

  const openAccountStatement = (university_id) => {
    getAccountStatements(university_id);
    setSelectedFranchise(franchises.find(f => f.id === university_id));
    setUniversityID(university_id);
    setShowAccountStatement(true);
  };

  const openStudentRegistration = (university_id) => {
    setUniversityID(university_id);
    setShowStudentModal(true);
  };

  const openUserRegistration = (university_id) => {
    setSelectedFranchise(franchises.find(f => f.id === university_id));
    setUniversityID(university_id);
    setShowModalUsers(true);
  };

  const selectedFranchiseForUpdate = (franchise) => {
    setUpdateFranchise(true);
    setFormData({
      university: {
        name: franchise.name,
        address: franchise.address,
        short_name: franchise.short_name,
        period_date_ini: franchise.franchises_universities?.period_date_ini,
        academic_period: franchise.franchises_universities?.academic_period,
        phone: franchise.phone,
        university_id: franchise.franchises_universities?.university_id
      },
      franchise: franchise.franchises_universities?.franchise,
      costs: franchise.cost_university
    });
    setShowForm(true);
  }

  return (
    <div className="container mx-auto p-4 max-w-6xl">
      <h1 className="text-2xl font-bold mb-6 text-gray-800">Gestión de Universidades y Franquicias</h1>
      
      <div className="flex justify-between mb-4">
        <button
          onClick={() => setShowForm(!showForm)}
          className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700"
        >
          {showForm ? '' : <i className=" mr-2 text-white fas fa-chevron-left"></i>}
          {showForm ? 'Ver Lista de Franquicias' : 'Nueva Franquicia'}
          {showForm ? <i className=" ml-2 text-white fas fa-chevron-right"></i> : ''}
        </button>
      </div>

      {showForm ? (
        /* Módulo de Captura */
        <div className="bg-white rounded-lg shadow-md p-6 mb-8">
          <h2 className="text-xl font-semibold mb-4 text-gray-800">Formulario de Registro</h2>
          
          <form onSubmit={handleSubmit}>
            {/* Pestañas */}
            <div className="flex border-b mb-6">
              <button
                type="button"
                className={`py-2 px-4 font-medium ${activeTab === 'franchise' ? 'text-red-600 border-b-2 border-red-600' : 'text-gray-500'}`}
                onClick={() => setActiveTab('franchise')}
              >
                Franquicia
              </button>
              <button
                type="button"
                className={`py-2 px-4 font-medium ${activeTab === 'university' ? 'text-red-600 border-b-2 border-red-600' : 'text-gray-500'}`}
                onClick={() => setActiveTab('university')}
              >
                Universidad
              </button>
              <button
                type="button"
                className={`py-2 px-4 font-medium ${activeTab === 'costs' ? 'text-red-600 border-b-2 border-red-600' : 'text-gray-500'}`}
                onClick={() => setActiveTab('costs')}
              >
                Costos
              </button>
            </div>

            {/* Formulario Universidad */}
            {activeTab === 'university' && (
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700">Nombre Universidad*</label>
                  <input
                    type="text"
                    value={formData.university.name}
                    onChange={(e) => handleInputChange('university', 'name', e.target.value)}
                    className="mt-1 block w-full rounded border-gray-300 shadow-sm p-2 border"
                    required
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700">Dirección</label>
                  <input
                    type="text"
                    value={formData.university.address}
                    onChange={(e) => handleInputChange('university', 'address', e.target.value)}
                    className="mt-1 block w-full rounded border-gray-300 shadow-sm p-2 border"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700">Nombre Corto*</label>
                  <input
                    type="text"
                    value={formData.university.short_name}
                    onChange={(e) => handleInputChange('university', 'short_name', e.target.value)}
                    className="mt-1 block w-full rounded border-gray-300 shadow-sm p-2 border"
                    required
                    maxLength="30"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700">Teléfono*</label>
                  <input
                    type="tel"
                    value={formData.university.phone}
                    onChange={(e) => handleInputChange('university', 'phone', e.target.value)}
                    className="mt-1 block w-full rounded border-gray-300 shadow-sm p-2 border"
                    required
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700">Periodo Acádemico</label>
                  <select
                    className="mt-1 block w-full rounded border-gray-300 shadow-sm p-2 border"
                    value={formData.university.academic_period}
                    onChange={(e) => handleInputChange('university', 'academic_period', e.target.value)}

                  >
                    <option value="6" >Semestre</option>
                    <option value="4" >Cuatrimestre</option>
                    <option value="3" >Trimestre</option>
                    <option value="2" >Bimestre</option>
                    <option value="12" >Anual</option>
                  </select>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700">Inicio del periodo*</label>
                  <input
                    type="date"
                    value={formData.university.period_date_ini}
                    onChange={(e) => handleInputChange('university', 'period_date_ini', e.target.value)}
                    className="mt-1 block w-full rounded border-gray-300 shadow-sm p-2 border"
                    required
                  />
                </div>
              </div>
            )}

            {/* Formulario Franquicia */}
            {activeTab === 'franchise' && (
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700">Nombre Franquicia*</label>
                  <input
                    type="text"
                    value={formData.franchise.name}
                    onChange={(e) => handleInputChange('franchise', 'name', e.target.value)}
                    className="mt-1 block w-full rounded border-gray-300 shadow-sm p-2 border"
                    required
                  />
                </div>
                {/* <div>
                  <label className="block text-sm font-medium text-gray-700">Dirección</label>
                  <input
                    type="text"
                    value={formData.franchise.address}
                    onChange={(e) => handleInputChange('franchise', 'address', e.target.value)}
                    className="mt-1 block w-full rounded border-gray-300 shadow-sm p-2 border"
                  />
                </div> */}
                <div>
                  <label className="block text-sm font-medium text-gray-700">Teléfono Principal</label>
                  <input
                    type="tel"
                    value={formData.franchise.phone}
                    onChange={(e) => handleInputChange('franchise', 'phone', e.target.value)}
                    className="mt-1 block w-full rounded border-gray-300 shadow-sm p-2 border"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700">Teléfono Secundario</label>
                  <input
                    type="tel"
                    value={formData.franchise.phone2}
                    onChange={(e) => handleInputChange('franchise', 'phone2', e.target.value)}
                    className="mt-1 block w-full rounded border-gray-300 shadow-sm p-2 border"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700">Email*</label>
                  <input
                    type="email"
                    value={formData.franchise.email}
                    onChange={(e) => handleInputChange('franchise', 'email', e.target.value)}
                    className="mt-1 block w-full rounded border-gray-300 shadow-sm p-2 border"
                    required
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700">Nombre Contacto*</label>
                  <input
                    type="text"
                    value={formData.franchise.name_contact}
                    onChange={(e) => handleInputChange('franchise', 'name_contact', e.target.value)}
                    className="mt-1 block w-full rounded border-gray-300 shadow-sm p-2 border"
                    required
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700">Teléfono Contacto</label>
                  <input
                    type="tel"
                    value={formData.franchise.phone_contact}
                    onChange={(e) => handleInputChange('franchise', 'phone_contact', e.target.value)}
                    className="mt-1 block w-full rounded border-gray-300 shadow-sm p-2 border"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700">Email Contacto</label>
                  <input
                    type="email"
                    value={formData.franchise.email_contact}
                    onChange={(e) => handleInputChange('franchise', 'email_contact', e.target.value)}
                    className="mt-1 block w-full rounded border-gray-300 shadow-sm p-2 border"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700">Estado</label>
                  <select
                    value={formData.franchise.status}
                    onChange={(e) => handleInputChange('franchise', 'status', e.target.value)}
                    className="mt-1 block w-full rounded border-gray-300 shadow-sm p-2 border"
                  >
                    <option value="Activo">Activo</option>
                    <option value="Inactivo">Inactivo</option>
                  </select>
                </div>
              </div>
            )}

            {/* Formulario Costos */}
            {activeTab === 'costs' && (
              <>
              <div>
                <label className="block font-bold text-gray-700 mb-5">Costo Mensual por Estudiante</label>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700">Licenciatura*</label>
                  <input
                    type="number"
                    value={formData.costs.cost_month_lic}
                    onChange={(e) => handleInputChange('costs', 'cost_month_lic', e.target.value)}
                    className="mt-1 block w-full rounded border-gray-300 shadow-sm p-2 border"
                    step="0.01"
                    required
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700">Ingeniería*</label>
                  <input
                    type="number"
                    value={formData.costs.cost_month_engineering}
                    onChange={(e) => handleInputChange('costs', 'cost_month_engineering', e.target.value)}
                    className="mt-1 block w-full rounded border-gray-300 shadow-sm p-2 border"
                    step="0.01"
                    required
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700">Maestría*</label>
                  <input
                    type="number"
                    value={formData.costs.cost_month_master}
                    onChange={(e) => handleInputChange('costs', 'cost_month_master', e.target.value)}
                    className="mt-1 block w-full rounded border-gray-300 shadow-sm p-2 border"
                    step="0.01"
                    required
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700">Doctorado*</label>
                  <input
                    type="number"
                    value={formData.costs.cost_month_doctorate}
                    onChange={(e) => handleInputChange('costs', 'cost_month_doctorate', e.target.value)}
                    className="mt-1 block w-full rounded border-gray-300 shadow-sm p-2 border"
                    step="0.01"
                    required
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700">Salud*</label>
                  <input
                    type="number"
                    value={formData.costs.cost_month_health}
                    onChange={(e) => handleInputChange('costs', 'cost_month_health', e.target.value)}
                    className="mt-1 block w-full rounded border-gray-300 shadow-sm p-2 border"
                    step="0.01"
                    required
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700">Especialidad*</label>
                  <input
                    type="number"
                    value={formData.costs.cost_month_specialty}
                    onChange={(e) => handleInputChange('costs', 'cost_month_specialty', e.target.value)}
                    className="mt-1 block w-full rounded border-gray-300 shadow-sm p-2 border"
                    step="0.01"
                    required
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700">Diplomado*</label>
                  <input
                    type="number"
                    value={formData.costs.cost_month_diploma}
                    onChange={(e) => handleInputChange('costs', 'cost_month_diploma', e.target.value)}
                    className="mt-1 block w-full rounded border-gray-300 shadow-sm p-2 border"
                    step="0.01"
                    required
                  />
                </div>
              </div>
              <div>
                <hr className='m-5' />
              </div>
              <div>
                <label className="block font-bold text-gray-700 mb-5">Costo de Titulación</label>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700">Licenciatura</label>
                  <input
                    type="number"
                    value={formData.costs.cost_degree_lic}
                    onChange={(e) => handleInputChange('costs', 'cost_degree_lic', e.target.value)}
                    className="mt-1 block w-full rounded border-gray-300 shadow-sm p-2 border"
                    step="0.01"
                    required
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700">Ingeniería</label>
                  <input
                    type="number"
                    value={formData.costs.cost_degree_engineering}
                    onChange={(e) => handleInputChange('costs', 'cost_degree_engineering', e.target.value)}
                    className="mt-1 block w-full rounded border-gray-300 shadow-sm p-2 border"
                    step="0.01"
                    required
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700">Maestría</label>
                  <input
                    type="number"
                    value={formData.costs.cost_degree_master}
                    onChange={(e) => handleInputChange('costs', 'cost_degree_master', e.target.value)}
                    className="mt-1 block w-full rounded border-gray-300 shadow-sm p-2 border"
                    step="0.01"
                    required
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700">Doctorado</label>
                  <input
                    type="number"
                    value={formData.costs.cost_degree_doctorate}
                    onChange={(e) => handleInputChange('costs', 'cost_degree_doctorate', e.target.value)}
                    className="mt-1 block w-full rounded border-gray-300 shadow-sm p-2 border"
                    step="0.01"
                    required
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700">Salud</label>
                  <input
                    type="number"
                    value={formData.costs.cost_degree_health}
                    onChange={(e) => handleInputChange('costs', 'cost_degree_health', e.target.value)}
                    className="mt-1 block w-full rounded border-gray-300 shadow-sm p-2 border"
                    step="0.01"
                    required
                  />
                </div>
              </div>
              <div>
                <hr className='m-5' />
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700">Costo de Inscripción*</label>
                  <input
                    type="number"
                    value={formData.costs.cost_inscription}
                    onChange={(e) => handleInputChange('costs', 'cost_inscription', e.target.value)}
                    className="mt-1 block w-full rounded border-gray-300 shadow-sm p-2 border"
                    step="0.01"
                    required
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700">Costo de Reinscripción*</label>
                  <input
                    type="number"
                    value={formData.costs.cost_reinscription}
                    onChange={(e) => handleInputChange('costs', 'cost_reinscription', e.target.value)}
                    className="mt-1 block w-full rounded border-gray-300 shadow-sm p-2 border"
                    step="0.01"
                    required
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700">Cargo por Día por Pago Tardío*</label>
                  <input
                    type="number"
                    value={formData.costs.late_payment}
                    onChange={(e) => handleInputChange('costs', 'late_payment', e.target.value)}
                    className="mt-1 block w-full rounded border-gray-300 shadow-sm p-2 border"
                    step="0.01"
                    required
                  />
                </div>
              </div>
              </>
            )}
            <div className=''>
            {message.status ? (
                <Alert className="mt-2" severity={message.label}>
                  {message.message}
                </Alert>
              ) : (
                ""
              )}
            </div>

            <div className="mt-6 flex justify-end">
              <button
                type="submit"
                className={`px-4 py-2 w-full  text-white rounded ${updateFranchise ? 'bg-yellow-600 hover:bg-yellow-700' : 'bg-red-600 hover:bg-red-700' }`}
              >
                { updateFranchise ? 'Actualizar Franquicia' : 'Guardar Franquicia' } 
              </button>
            </div>
          </form>
        </div>
      ) : (
        /* Lista de Franquicias */
        <div className="bg-white rounded-lg shadow-md p-6">
          <FinancialSummary globalSummary={globalSummary} />
          <h2 className="text-xl font-semibold mb-4 text-gray-800">Lista de Franquicias</h2>

          {/* Tabs activas / archivadas */}
          <div className="flex border-b mb-4">
            <button
              className={`py-2 px-4 font-medium text-sm ${franchiseListTab === 'active' ? 'text-red-600 border-b-2 border-red-600' : 'text-gray-500 hover:text-gray-700'}`}
              onClick={() => setFranchiseListTab('active')}
            >
              Activas
              <span className="ml-2 bg-gray-100 text-gray-600 text-xs px-2 py-0.5 rounded-full">
                {franchises.filter(f => !f.franchises_universities?.franchise?.archived_at).length}
              </span>
            </button>
            <button
              className={`py-2 px-4 font-medium text-sm ${franchiseListTab === 'archived' ? 'text-red-600 border-b-2 border-red-600' : 'text-gray-500 hover:text-gray-700'}`}
              onClick={() => setFranchiseListTab('archived')}
            >
              Archivadas
              <span className="ml-2 bg-gray-100 text-gray-600 text-xs px-2 py-0.5 rounded-full">
                {franchises.filter(f => !!f.franchises_universities?.franchise?.archived_at).length}
              </span>
            </button>
          </div>

          <div className=''>
            {messageGeneral.status ? (
                <Alert className="mt-2" severity={messageGeneral.label}>
                  {messageGeneral.message}
                </Alert>
              ) : (
                ""
              )}
            </div>
          <div className="overflow-x-auto">
            <table className="min-w-full bg-white border border-gray-200 text-xs">
              <thead>
                <tr className="bg-gray-200">
                  <th className="py-2 px-4 border-b text-left text-xs text-gray-700">CLAVE</th>
                  <th className="py-2 px-4 border-b text-left text-xs text-gray-700">CAMPUS</th>
                  <th className="py-2 px-4 border-b text-left text-xs text-gray-700">TELÉFONO</th>
                  <th className="py-2 px-4 border-b text-left text-xs text-gray-700">LIC</th>
                  <th className="py-2 px-4 border-b text-left text-xs text-gray-700">ING</th>
                  <th className="py-2 px-4 border-b text-left text-xs text-gray-700">MTRIA</th>
                  <th className="py-2 px-4 border-b text-left text-xs text-gray-700">DOC</th>
                  <th className="py-2 px-4 border-b text-left text-xs text-gray-700">SALUD</th>
                  <th className="py-2 px-4 border-b text-left text-xs text-gray-700">ESP</th>
                  <th className="py-2 px-4 border-b text-left text-xs text-gray-700">DIPL</th>
                  <th className="py-2 px-4 border-b text-left text-xs text-gray-700">INSCRIPCIÓN</th>
                  <th className="py-2 px-4 border-b text-left text-xs text-gray-700">REINSCRIPCIÓN</th>
                  {/* <th className="py-2 px-4 border-b text-left text-xs text-gray-700">TÍTULO</th> */}
                  <th className="py-2 px-4 border-b text-left text-xs text-gray-700">TARDÍO/DÍA</th>
                </tr>
              </thead>
              <tbody>
                {franchises
                  .filter(f => franchiseListTab === 'active'
                    ? !f.franchises_universities?.franchise?.archived_at
                    : !!f.franchises_universities?.franchise?.archived_at
                  )
                  .map((franchise) => (
                  <React.Fragment key={franchise.id}>
                    <tr 
                      className={`hover:bg-gray-50 cursor-pointer ${
                        selectedFranchise?.id === franchise.id ? 'bg-gray-100' : `${franchise.franchises_universities?.franchise?.status === 'Activo' ? 'bg-gray-50' : 'bg-red-100'}`
                      }`}
                      onClick={() => setSelectedFranchise(
                        selectedFranchise?.id === franchise.id ? null : franchise
                      )}
                    >
                      <td className="py-2 px-4 border-b">{franchise.id}</td>
                      <td className="py-2 px-4 border-b">{franchise.short_name}</td>
                      <td className="py-2 px-4 border-b">{franchise.phone}</td>
                      <td className="py-2 px-4 border-b">{formatMoney(franchise.cost_university?.cost_month_lic)}</td>
                      <td className="py-2 px-4 border-b">{formatMoney(franchise.cost_university?.cost_month_engineering)}</td>
                      <td className="py-2 px-4 border-b">{formatMoney(franchise.cost_university?.cost_month_master)}</td>
                      <td className="py-2 px-4 border-b">{formatMoney(franchise.cost_university?.cost_month_doctorate)}</td>
                      <td className="py-2 px-4 border-b">{formatMoney(franchise.cost_university?.cost_month_health)}</td>
                      <td className="py-2 px-4 border-b">{formatMoney(franchise.cost_university?.cost_month_specialty)}</td>
                      <td className="py-2 px-4 border-b">{formatMoney(franchise.cost_university?.cost_month_diploma)}</td>
                      <td className="py-2 px-4 border-b">{formatMoney(franchise.cost_university?.cost_inscription)}</td>
                      <td className="py-2 px-4 border-b">{formatMoney(franchise.cost_university?.cost_reinscription)}</td>
                      {/* <td className="py-2 px-4 border-b">{formatMoney(franchise.cost_university?.cost_degree)}</td> */}
                      <td className="py-2 px-4 border-b">{formatMoney(franchise.cost_university?.late_payment)}</td>
                    </tr>
                    
                    {selectedFranchise?.id === franchise.id && (
                      <tr className="bg-gray-100">
                        <td colSpan="14" className="py-4 px-4 border-b">
                          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <div>
                              <h3 className="font-medium mb-2">Información de Contacto</h3>
                              <p><span className="font-semibold">Nombre:</span> {franchise.franchises_universities?.franchise?.name}</p>
                              <p><span className="font-semibold">Contacto:</span> {franchise.franchises_universities?.franchise?.name_contact}</p>
                              <p><span className="font-semibold">Teléfono:</span> {franchise.franchises_universities?.franchise?.phone_contact}</p>
                              <p><span className="font-semibold">Email:</span> {franchise.franchises_universities?.franchise?.email}</p>
                              <p><span className="font-semibold">Estado:</span>
                                <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${  franchise.franchises_universities?.franchise?.status === 'Activo' ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`}>
                                  {franchise.franchises_universities?.franchise?.status}
                                </span>
                              </p>
                            </div>
                            <div>
                              <h3 className="font-medium mb-2">Acciones</h3>
                              <div className="flex flex-wrap gap-2">
                                <button
                                  className="px-3 py-1 bg-green-600 text-white rounded hover:bg-red-700 text-sm"
                                  onClick={() => openAccountStatement(franchise.id)}
                                >
                                  <i className=" mr-2 text-white fas fa-file-invoice"></i>
                                  Estado de Cuenta
                                </button>
                                <button
                                  className="px-3 py-1 bg-green-600 text-white rounded hover:bg-red-700 text-sm"
                                  onClick={() => openStudentRegistration(franchise.id)}
                                >
                                  <i className=" mr-2 text-white fas fa-users"></i>
                                  Alumnos
                                </button>
                                <button
                                  className="px-3 py-1 bg-green-600 text-white rounded hover:bg-red-700 text-sm"
                                  onClick={() => openUserRegistration(franchise.id)}
                                >
                                  <i className=" mr-2 text-white fas fa-user"></i>
                                  Usuarios
                                </button>
                              </div>
                              <div className="flex flex-wrap gap-2 mt-2">
                                <button 
                                  className="px-3 py-1 bg-yellow-600 text-white rounded hover:bg-yellow-700 text-sm"
                                  onClick={() => selectedFranchiseForUpdate(franchise)}
                                >
                                  Editar
                                </button>
                                <button
                                  className={`px-3 py-1  text-white rounded ${franchise.franchises_universities?.franchise?.status === 'Activo' ? 'bg-yellow-600 hover:bg-yellow-700' : 'bg-sky-600 hover:bg-sky-700'}  text-sm`}
                                  onClick={()=>toggleDeactivate(franchise)}
                                >
                                  {franchise.franchises_universities?.franchise?.status === 'Activo' ? 'Desactivar' : 'Activar'}
                                </button>
                                <button
                                  className={`px-3 py-1 text-white rounded text-sm ${franchise.franchises_universities?.franchise?.archived_at ? 'bg-green-600 hover:bg-green-700' : 'bg-gray-500 hover:bg-gray-600'}`}
                                  onClick={() => toggleArchive(franchise)}
                                >
                                  <i className={`fas ${franchise.franchises_universities?.franchise?.archived_at ? 'fa-box-open' : 'fa-archive'} mr-1`}></i>
                                  {franchise.franchises_universities?.franchise?.archived_at ? 'Desarchivar' : 'Archivar'}
                                </button>
                                {/* <button className="px-3 py-1 bg-red-600 text-white rounded hover:bg-red-700 text-sm">
                                  Eliminar
                                </button> */}
                              </div>
                            </div>
                          </div>
                        </td>
                      </tr>
                    )}
                  </React.Fragment>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {!showForm && (
        <div className="bg-white rounded-lg shadow-md p-6 mt-6">
          <h2 className="text-xl font-semibold mb-4 text-gray-800">Resumen por Franquicia</h2>
          <FranchiseStats data={franchiseStats} />
        </div>
      )}

      {showAccountStatement && selectedFranchise && (
        <ModalAccount 
          selectedMonth = {selectedMonth}
          setSelectedMonth = {setSelectedMonth}

          accountStatements = {accountStatements}
          selectedFranchise = {selectedFranchise}
          setShowAccountStatement = {setShowAccountStatement} 

          universityID = {universityID}
          setUpdateInvoiceData = {setUpdateInvoiceData}

          getAccountStatements = {getAccountStatements}
          getGlobalSummary = {getGlobalSummary}
          globalSummary = {globalSummary}

          creditBalanceFranchis = {creditBalanceFranchis}

          selectedInvoice = {selectedInvoice}
        />
      )}

      {showModalUsers && selectedFranchise && (
        <ModalUsers
          selectedFranchise = {selectedFranchise}
          setShowModalUsers = {setShowModalUsers} 
          universityID= {universityID}
        />
      )}

      {showStudentModal && (
        <ModalStudentRegistration 
          onClose={() => setShowStudentModal(false)}
          universityID={universityID}
        />
      )}

    </div>
  );
};

export default UniversityManagementSystem;